




































// vue
import {
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
} from '@vue/composition-api';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';
import { useGeometryHoverHook } from '@/vue3/hooks/geometryHoverHook';

// services
import { useService } from '@/vue3/api/services';

// config
import geoRecordLayers from '@/vue3/configs/geoRecordLayers';

// primevue
import Slider from 'primevue/slider';
import InputNumber from 'primevue/inputnumber';

export default defineComponent({
    components: {
        Slider,
        InputNumber,
    },
    props: {
        mapbox: {
            type: Object,
            default: null,
        },
    },
    setup(props: any) {
        // hooks
        const {
            refreshGeoRecord,
            refreshGeoRecordExtrusion,
            updateGeoRecordExtrusion,
        } = useGeoRecord();
        const { smoothGeoRecord } = useService();
        const { highlightGeometry, highlightGeoRecordExtrusions } =
            useGeometryHoverHook();

        // reactive
        const smoothRecord = ref();
        const intensity = ref(3);

        // methods
        const getFeatureSmooth = async (featureId) => {
            smoothRecord.value = await smoothGeoRecord(
                featureId,
                intensity.value,
            );
            if (smoothRecord.value !== undefined) {
                updateGeoRecordExtrusion(
                    props.mapbox.map,
                    smoothRecord.value.data,
                );
                refreshGeoRecordExtrusion(
                    props.mapbox.map,
                    smoothRecord.value.data,
                );
                refreshGeoRecord(
                    props.mapbox?.map,
                    smoothRecord.value.data,
                    true,
                );
                props.mapbox.map.on('mousemove', onMouseMove);
            }
            activateMouseMove();
        };

        const getFeatureId = (e) => {
            const featureId = props.mapbox.map.queryRenderedFeatures(e.point);
            featureId.length > 0 ? getFeatureSmooth(featureId[0].id) : '';
        };

        const onMouseMove = (e) => {
            const feature = e;
            highlightGeometry(feature, props.mapbox.map, 'geo-records');
        };

        const hoverExtrusion = (e) => {
            if (props.mapbox.map.getLayer('polygon-extrusion')) {
                highlightGeoRecordExtrusions(
                    e,
                    props.mapbox.map,
                    'polygon-extrusion',
                );
            }
        };

        const activateMouseMove = () => {
            props.mapbox.map.on('mousemove', hoverExtrusion);
            geoRecordLayers.forEach((geoRecordLayer) => {
                props.mapbox.map.on(
                    'mousemove',
                    geoRecordLayer.id,
                    onMouseMove,
                );
                props.mapbox.map.on(
                    'mouseleave',
                    geoRecordLayer.id,
                    onMouseMove,
                );
            });
        };

        const deActivateMouseMove = () => {
            props.mapbox.map.off('mousemove', hoverExtrusion);
            geoRecordLayers.forEach((geoRecordLayer) => {
                props.mapbox.map.off(
                    'mousemove',
                    geoRecordLayer.id,
                    onMouseMove,
                );
                props.mapbox.map.off(
                    'mouseleave',
                    geoRecordLayer.id,
                    onMouseMove,
                );
            });
        };
        // lifecycle
        onMounted(() => {
            props.mapbox.map.on('click', getFeatureId);
            activateMouseMove();
        });

        onUnmounted(() => {
            props.mapbox.map.off('click', getFeatureId);
            deActivateMouseMove();
        });
        return { intensity };
    },
});
